module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"pending_reviews":"작성 가능한 리뷰 {count}","written_reviews":"내가 작성한 리뷰 {count}"}}')
  delete Component.options._Ctor
}
